

export class PoiTypeOutputWithStatus implements IPoiTypeOutputWithStatus {
    /** The auto-generated id of the poi type master */
    poi_type_id!: number;
    /** The poi type name with 255 character limit */
    poi_type_name!: string;
    /** Manage status of poi type. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IPoiTypeOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poi_type_id = _data["poi_type_id"];
            this.poi_type_name = _data["poi_type_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): PoiTypeOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new PoiTypeOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poi_type_id"] = this.poi_type_id;
        data["poi_type_name"] = this.poi_type_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IPoiTypeOutputWithStatus {
    /** The auto-generated id of the poi type master */
    poi_type_id: number;
    /** The poi type name with 255 character limit */
    poi_type_name: string;
    /** Manage status of poi type. 0 For De-active, 1 For Active */
    status: number;
}

